export default "__VITE_ASSET__RonxEcSz__"